<template>
  <div class="shadow overflow-y-auto border-b border-gray-200 sm:rounded-lg scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray max-h-96">
    <table class="min-w-full divide-y divide-gray-200 table-collapse">
      <thead>
        <tr v-if="blueprint.document !== undefined">
          <template  v-for="column in blueprint.document.fields">
            <th  :key="column.index" class="z-5 sticky top-0 px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
              {{column.label}}
            </th>
          </template>
            <th class="z-5 sticky top-0 px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
              Estado
            </th>
            <th class="z-5 sticky top-0 px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
              Acciones
            </th>
        </tr>
        <tr v-else>
          <th class="z-5 sticky top-0 px-6 py-5 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
          </th>
        </tr>

      </thead>
      <tbody v-if="blueprint.document !== undefined" class="bg-white divide-y divide-gray-300">
        <tr v-for="record in records" :key="record.id">
          <template  v-if="Object.keys(record.data.data).length !== 0" >
            <template v-for="column in blueprint.document.fields">
              <td v-if="record.data.data[column.key] !== undefined" :key="column.key" class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-900">
                {{formatValue(record, column.key)}}
              </td>
              <td v-else v-bind:key="column.key">
              </td>
            </template>
          </template>

          <td v-if="record.completed" class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-900">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              Completo
            </span>
          </td>
          <td v-else class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-900">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
              Incompleto
            </span>
          </td>


          <td class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-900">
            <button type="button" class="inline-flex items-center py-1.5 text-xs leading-4 font-bold rounded text-blue-900 bg-white focus:outline-none active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
                v-on:click.stop="downloadReport(record)">
              Descargar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios';
import { getUnixTime } from 'date-fns';

import { format } from 'date-fns'
export default {
  name: 'flow-dynamic-table',
  created() {
  },
  props: {
    blueprint: Object
  },
  data() {
    return {
      items: [],
    }
  },
  watch: {
    blueprint: function(val) {
      if (val !== undefined) {
        this.fetchItems()
      }
    },
    range() {
      this.fetchItems()
    }
  },
  computed: {
    ...mapGetters(['records', 'innerStart', 'innerEnd']),
    start() {
      return getUnixTime(this.innerStart);
    },
    end() {
      return getUnixTime(this.innerEnd);
    },
    range() {
      return { start: this.$store.getters.innerStart, end: this.$store.getters.innerEnd }
    },
  },
  methods: {
    ...mapActions(['getRecords']),

    async fetchItems() {
      console.log(this.range.start, this.range.end)
      await this.getRecords({
        blueprintid: this.blueprint.id,
        start: getUnixTime(this.range.start),
        end: getUnixTime(this.range.end)}
      )
    },

    formatValue(record, key) {
      let field = this.blueprint.document.fields.find(e => e.key === key)
      if (field.type === 'datetime') {
        return format(new Date(record.data.data[key].value), "dd-MM-yyyy")
      } else if (field.type === 'date') {
        return format(new Date(record.data.data[key].value), "dd-MM-yyyy")
      }
      const value = record.data.data[key].value
      return value
    },

    async downloadReport(record) {
      const response = await this.$http.get(`flow/record_xlsx/${record.id}`);
      await axios
        .get(`${process.env.VUE_APP_ROOT_REPORTS}${response.data.url}`, { responseType: 'blob' })
        .then(async res => ({
          blob: await new Blob([res.data], {
            type: 'application/pdf'
          }),
          filename: response.data.url
        }))
        .then(res => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(res.blob);
          link.download = res.filename;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    }
  }
}
</script>
